/* eslint-disable */
import store from '@/store/index'

class UuidGenerator {
  uuid:any

  constructor() {
    window.parent.postMessage(`widgetIndentificator.getStorage()`, '*')
  }

  setUuid (data:any) {
    if (!data) {
      this.generateChatUuid()
    } else {
      this.uuid = data
      store.state.widget.uuid = this.uuid
    }
  }

  uuidGenerator () {
    let d = new Date().getTime()
    let d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0

    this.uuid = 'yxyxy-xxxx-4xyxyxyxyxyxxx-yxxx-xxxxxxxxyxyxyxyx'.replace(/[xy]/g, (c) => {
      let r = Math.random() * 16
      if (d > 0) {
        r = (d + r) % 16 | 0
        d = Math.floor(d/16)
      } else {
        r = (d2 + r) % 16 | 0
        d2 = Math.floor(d2/16)
      }

      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
    })

    return this.uuid
  }

  generateChatUuid () {
    this.uuidGenerator()
    store.state.widget.uuid = this.uuid

    window.parent.postMessage(`widgetIndentificator.setStorage(${JSON.stringify(this.uuid)})`, '*')

    return store.state.widget.uuid
  }
}
const uuidGenerator = <any> new UuidGenerator()

const receiver = (event: any) => {
  const message = event.data;

  if (!message || typeof message !== 'string' || message.includes('webpack')) {
    return false;
  }

  const expression = message.split('(');
  const keyFunctionName = expression[0];
  const dataString = message.slice(`${keyFunctionName}(`.length, -1);

  const func = keyFunctionName.split('.')[1];
  const params = JSON.parse(`[${dataString}]`);

  try {
    uuidGenerator[func](...params);
  } catch (error) {
    // console.error(`Función ${keyFunctionName} no encontrada o no es una función válida.`);
  }
}

window.addEventListener('message', receiver, false);
